import React from "react";
import { DotLegalPaper } from "@dotlegal/dotlegal-ui-components";

// The paper takes what is left of the window, and the internally scrolling table inside it takes what is left of the
// paper. On a short window, or with browser zoom or display scaling, that would be only a row or two, so below this
// floor the paper stops shrinking and the page scrolls instead.
const tablePagePaperMinHeight = 500;

export interface TablePagePaperProps {
    children: React.ReactNode;
    removePadding?: boolean;
}

function TablePagePaper(props: TablePagePaperProps) {
    return (
        <DotLegalPaper
            fullHeight
            removePadding={props.removePadding}
            sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: tablePagePaperMinHeight }}
        >
            {props.children}
        </DotLegalPaper>
    );
}

export default TablePagePaper;
